import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ContactInformationComponent } from './contact-information.component';
import { ContactInformationService } from './contact-information.service';
import { CtModelModule, CtButtonModule } from '@ctsolution/ct-framework';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Modulo per ContactInformationComponent
 */
@NgModule({
  declarations: [ContactInformationComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    CtModelModule,
    CtButtonModule,
    MatCardModule,
    TranslateModule
  ],
  exports: [ContactInformationComponent],
  providers: [ContactInformationService]
})
export class ContactInformationModule {}
